import { render } from "./ModalPartner.vue?vue&type=template&id=e0eda540"
import script from "./ModalPartner.vue?vue&type=script&lang=js"
export * from "./ModalPartner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__